module.exports = __webpack_public_path__ + "static/img/irole.09d8f65.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/sy/irole.png
// module id = l7P2
// module chunks = 7